import { Vue, Component, Ref, Watch, PropSync } from "vue-property-decorator";
import CardListDetailNavigationOptions from "@/interfaces/Base/CardListDetail/CardListDetailNavigationOption";

@Component
export default class CardListDetailDetailCardMixin extends Vue {
  @Ref()
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  baseDetailCard!: any;

  /** The item from the list the user currently has selected */
  @PropSync("selectedItemSync", { type: Object, default: null })
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  selectedItem!: any | null;

  /** The current layer the user is on. Used when there is nested data. */
  selectedLayer = "";

  /** Loading data indicator. */
  loading = false;

  /** The navigation options available to the user depending on which layer they are on.
   *  Used when there is nested data. */
  navigationOptions = { name: "Details" } as CardListDetailNavigationOptions;

  moveToLayer(layerName: string): void {
    this.baseDetailCard.pushBreadcrumb(layerName);
  }

  @Watch("selectedItem")
  async selectedItemChanged(): Promise<void> {
    //calls the selectedItemChanged function in the component using this mixin
  }

  @Watch("selectedLayer")
  async selectedLayerChanged(): Promise<void> {
    //calls the selectedLayerChanged function in the component using this mixin
  }
}
